import tpmsIcon from '../../../Assets/technical_info/tpms_icon.png'

const TechnicalLV13 = () => {
    return (
        <div>
            <p><span style={ { fontSize: "24px" } }><strong>TPMS</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;TPMS (riepu spiediena kontroles sistēma jeb Tire Pressure Monitoring System) ir automobiļos iebūvēta sistēma, kas paredzēta riepu iekšējā spiediena uzraudzīšanai. Izšķir tiešās un netiešās sistēmas. Ja vienā vai vairākās riepās notiek spiediena zudums, par to nekavējoties tiek brīdināts vadītājs ar signālu mēraparātu panelī.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Galvenās funkcijas</strong></span></p>

            <p>&nbsp;</p>

            <ul>
                <li>Uzlabo braukšanas drošību</li>
                <li>Palīdz novērst palielinātu degvielas patēriņu, ko izraisa nepareizs spiediens riepās</li>
                <li>Palīdz novērst pastiprinātu riepu nodilumu, ko izraisa pazemināts spiediens riepās</li>
            </ul>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Galvenā priekšrocība</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Spiediena krišanās konstatēšana notiek reālajā laikā, un spiedienu var koriģēt vēl pirms bojājumu rašanās.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Kā darbojas tiešā TPMS</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Izmantojot tiešo sistēmu, devējs nosaka gaisa spiedienu un temperatūru riepā. Šī informācija ar radioviļņu palīdzību tiek pārraidīta kontroles ierīcei automobilī. Atkarībā no displeja koncepcijas braucējs var vai nu pastāvīgi nolasīt tekošos spiediena lielumus kā tīru tekstu, vai arī saņemt tikai brīdinājuma signālu par pazeminātu spiedienu. Šī sistēma ļauj noteikt pakāpenisku un strauju spiediena zudumu riepā, jo tā kontrolē spiedienu tiešā veidā.</p>

            <p><img alt="TPMS" src={tpmsIcon} style={ { width: "min(100%, 300px)", height: "auto", display: "block", margin: "auto" } } /></p>

            <p><span style={ { fontSize: "24px" } }><strong>Kā darbojas netiešā TPMS</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Netiešā sistēma ņem vērā riteņu rotācijas ātrumu, lai noteiktu riepas spiedienu vai spiediena zudumu. Rotācijas ātruma noteikšanu veic automobilī iebūvētie ABS sensori vai arī vilkmes kontroles sensori.</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Netiešā sistēma izmanto divus fizikālos lielumus:</p>

            <ul>
                <li>Riteņa apkārtmērs. Ja spiediens riepā krītas, riteņa diametrs samazinās. Šī riteņa rotācijas ātrums salīdzinājumā ar citiem riteņiem pieaugs.</li>
                <li>Frekvence. Piedziņas riteņiem ir specifisks vibrāciju veids, kas ir atkarīgs no spiediena, un sistēma noteiks spiediena zudumu no vibrācijas veida izmaiņām.</li>
            </ul>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Priekšrocības un trūkumi</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Tiešā TPMS iegūst ļoti precīzus datus, un tā var sniegt papildus rādījumus, piemēram, riepas pozīcijas noteikšanu, spiediena zuduma noteikšanu stāvošam automobilim vai arī kontrolēt rezerves riteni. No otras puses šī sistēma prasa papildus darbu, veicot automobiļa apkopes vai mainot riepas. Papildus tam visiem viena un tā paša automobiļa riteņiem, t.i. ziemas, vasaras un rezerves riteņiem, jābūt aprīkotiem ar darbojošiem sensoriem.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Salīdzinoši netiešā TPMS nav tik precīza savā darbībā, jo tā, piemēram, nevar nomērīt temperatūru vai spiedienu. Tā nevar noteikt arī spiedienu stāvošam automobilim. Tomēr riepu maiņa ir ievērojami vieglāka, jo nav jāpievērš uzmanība riepu sensoriem. Garākā braucienā šī sistēma var izraisīt nepareizu riepu spiediena interpretāciju, jo netiešā sistēma nepārbauda vajadzīgo spiedienu, bet gan reģistrē aktuālo lielumu novirzes.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>TPMS izmantošana</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;TPMS izmantošana braucot un veicot automobiļa apkopes ietekmē gan automobiļa īpašnieku, gan arī servisu. Tas sevišķi attiecas uz tiešās TPMS izmantošanu. Gadījumā, ja ir tukša riepa vai bojāts sensors, būs jāuzticas kvalificētu darbnīcu pakalpojumiem.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Normatīvās prasības</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Būtībā, atbilstoši ES likumdošanai, automobiļa ražotājam ir jāuzstāda TPMS jau uz konveijera. Tomēr augstākminētā likumdošana neparedz, kāda tieši sistēma ir jāizmanto. Tāpēc gan tiešā, gan netiešā sistēma ir atļauta, ievērojot ECE-R 64 ietvertos nosacījumus un prasības.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;ECE-R 64 definē funkcionalitāti, ko nodrošina oriģinālie vai aksesuāru sensori. Tas nozīmē, ka visi aksesuāru jeb rezerves daļu tirgus sensori, kas varētu tikt izmantoti automobiļu riteņos, ir atļauti.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Svarīgi zināt, ka nefunkcionējoša TPMS, kas ir konstatēta vispārējās tehniskās apskates laikā, ir klasificējama kā maza kļūme, un automobiļa īpašniekam ir jānodrošina, lai tā tiktu savesta kārtībā.</p>
        </div>
    );
};

export default TechnicalLV13;


